var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"سجل المستخدم"}},[_c('log-timeline',{attrs:{"events":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }